import { render, staticRenderFns } from "./inquiryResult.vue?vue&type=template&id=3d93bb8a&scoped=true"
import script from "./inquiryResult.vue?vue&type=script&lang=js"
export * from "./inquiryResult.vue?vue&type=script&lang=js"
import style0 from "./inquiryResult.vue?vue&type=style&index=0&id=3d93bb8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d93bb8a",
  null
  
)

export default component.exports